import React from "react";
import { IssueCertificateLink } from "../../../elements/IssueCertificateLink";

interface CertificateButtonsProps {
	isCourseFinished: boolean;
	isCourseComplete: boolean;
	courseCertificateUrl: string | null;
	hasCertificate: boolean;
	sealAvailable: boolean;
	sealUrl: string | null;
}

/**
 * Component that renders certificate and seal download buttons
 * Only shows when course is finished and complete
 */
const CertificateButtons: React.FC<CertificateButtonsProps> = ({
	isCourseFinished,
	isCourseComplete,
	courseCertificateUrl,
	hasCertificate,
	sealAvailable,
	sealUrl,
}) => {
	const showCertificateButton =
		isCourseFinished &&
		isCourseComplete &&
		courseCertificateUrl &&
		courseCertificateUrl !== "#" &&
		hasCertificate;

	const showSealButton =
		sealAvailable &&
		isCourseFinished &&
		isCourseComplete &&
		sealUrl;

	if (!showCertificateButton && !showSealButton) {
		return null;
	}

	return (
		<div role="region" aria-label="Certificados disponíveis">
			{showCertificateButton && (
				<IssueCertificateLink certificateUrl={courseCertificateUrl} />
			)}
			{showSealButton && (
				<IssueCertificateLink isSeal certificateUrl={sealUrl} />
			)}
		</div>
	);
};

export { CertificateButtons };
